import CRBCLogo from "../logo";
import AuthenticatedSideBarItems from "./authenticated-sidebar-Items";
import { useAuth } from "react-oidc-context";

export default function Sidebar() {
  const auth = useAuth();
  const buildVersion = process.env.REACT_APP_BUILD_VERSION
    ? `v${process.env.REACT_APP_BUILD_VERSION}`
    : "(dev)";

  return (
    <div className="d-flex flex-column flex-shrink-0 p-3 sidebar d-none d-md-none d-lg-flex">
      <a href="/" className="d-flex align-items-center mb-5 mt-2 text-decoration-none">
        <CRBCLogo />
        <span className="ms-3 logo-text">
          MIS Central
          <span className="badge rounded-pill text-bg-secondary ms-2 build-version-badge">{buildVersion}</span>
        </span>
      </a>
      <AuthenticatedSideBarItems
        isAuthenticated={auth.isAuthenticated}
        logout={null}
      />
    </div>
  );
}